import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { msalApp } from '../auth-utils.js';
import { AppName } from '../App.js';

const Logout = (props) => {
    const { UserName, ClearAccess } = props;
    const ls = require('local-storage');

    useEffect(() => {
        //const logoutRequest = {
        //    account: msalApp.getAccountByUsername(userName)
        //}

        //msalApp.logout();
        ClearAccess();
        localStorage.clear();
    }, []);

    const login = () => {
        window.location.href = '/';
    };

    return (<div>
        <fieldset>
            <legend className="text-secondary border-bottom mb-0 pb-0">You have been Logged Out of {AppName}</legend>
            <em className="text-right d-block text-muted">{UserName || ''}</em>
            <p>Click below, if you would like to log back in.</p>
            <div>
                <Button onClick={login}>Log In</Button>
            </div>
        </fieldset>
    </div>);
};

export default Logout;


// WEBPACK FOOTER //
// ./src/components/Logout.js